import { Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { useFormatMessage } from '../../intl/intl';
import StoresFilterButton from '../stores-filter-button';
import OrderSearchTextField from '../order-search-text-field';
import { ordersKanbanSelector } from '../../redux/selectors/orders-kanban';
import {
  ScheduleOrdersTabs,
  useScheduleTab,
  useScheduledOrdersQuery,
} from 'features/order/scheduled';

import { textIds } from './const';
import useStyles from './OrdersKanbanAdvancedFiltersToolbar.styles';

function OrdersKanbanAdvancedFiltersToolbar(props) {
  const { showStoresFilterButton, title } = props;
  const _classes = useStyles();
  const advancedFiltersText = useFormatMessage(textIds.advancedFiltersText);
  const { activeTab, setActiveTab } = useScheduleTab();
  const pendingOrders = useSelector(ordersKanbanSelector.pendingOrders);
  const inCooking = useSelector(ordersKanbanSelector.inCooking);
  const amountInToDeliver = useSelector(ordersKanbanSelector.amountInToDeliver);
  const { data: scheduledOrders } = useScheduledOrdersQuery();

  const inProgressCount =
    pendingOrders.length + inCooking.length + amountInToDeliver;
  const scheduledCount = scheduledOrders?.length ?? 0;

  return (
    <Box className={_classes.root}>
      <Box className={_classes.leftCluster}>
        <Typography className={_classes.seccionTitle}>{title}</Typography>
        <Box className={_classes.tabsContainer}>
          <ScheduleOrdersTabs
            value={activeTab}
            onChange={setActiveTab}
            inProgressCount={inProgressCount}
            scheduledCount={scheduledCount}
          />
        </Box>
      </Box>
      <Box className={_classes.rightCluster}>
        <Typography className={_classes.advancedFiltersText}>
          {advancedFiltersText}
        </Typography>
        <OrderSearchTextField
          fullWidth={true}
          classes={{
            root: _classes.orderSearchTextFieldRoot,
            input: _classes.input,
          }}
        />
        {showStoresFilterButton && <StoresFilterButton />}
      </Box>
    </Box>
  );
}

export default OrdersKanbanAdvancedFiltersToolbar;
